import { Outlet, Route, Routes } from 'react-router-dom';
import * as Sentry from '@sentry/react';

import { HostedFormContainer } from '@percent/hosted-validation-form/app/HostedForm/HostedFormContainer';

import { AppRoute } from './AppRoute.enum';
import { InvalidLink } from '../app/InvalidLink/InvalidLink';

const SentryRoutes = Sentry.withSentryReactRouterV6Routing(Routes);

export const AppRoutes = () => {
  return (
    <SentryRoutes>
      <Route path={AppRoute.HOME}>
        <Route index element={<InvalidLink />} />
        <Route path={AppRoute.VALIDATE} element={<Outlet />}>
          <Route index element={<InvalidLink />} />
          <Route path={AppRoute.VALIDATE_ID} element={<HostedFormContainer />} />
        </Route>
        <Route path={AppRoute.NOT_FOUND} element={<InvalidLink />} />
      </Route>
    </SentryRoutes>
  );
};
